import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-6 text-center pt-[120px]">
      <div className="space-y-6 max-w-md">
        {/* Ikon med værksteds-tema */}
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-stone-100 text-brand-orange border border-stone-200 shadow-xs relative">
          <i className="fa-solid fa-triangle-exclamation text-4xl" />
          <span className="absolute -bottom-1 -right-1 flex h-8 w-8 items-center justify-center rounded-full bg-brand-green text-white text-xs font-bold border-2 border-white">
            404
          </span>
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl font-black tracking-tight text-brand-stone-dark sm:text-4xl">
            Siden blev ikke fundet
          </h1>
          <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
            Beklager, men den side du leder efter, findes ikke eller er blevet flyttet. Det kan skyldes en forkert URL eller et forældet link.
          </p>
        </div>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto rounded-xl bg-brand-green px-6 py-3 text-sm font-bold text-white shadow-md transition hover:bg-brand-green-light cursor-pointer"
          >
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto rounded-xl bg-stone-100 border border-stone-200 px-6 py-3 text-sm font-bold text-brand-stone-dark transition hover:bg-stone-200 cursor-pointer"
          >
            Kontakt værkstedet
          </Link>
        </div>
      </div>
    </div>
  );
}

export function Forbidden() {
  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-6 text-center pt-[120px]">
      <div className="space-y-6 max-w-md">
        {/* Ikon med lås */}
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-stone-100 text-brand-orange border border-stone-200 shadow-xs relative">
          <i className="fa-solid fa-lock text-4xl" />
          <span className="absolute -bottom-1 -right-1 flex h-8 w-8 items-center justify-center rounded-full bg-brand-green text-white text-xs font-bold border-2 border-white">
            403
          </span>
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl font-black tracking-tight text-brand-stone-dark sm:text-4xl">
            Adgang nægtet
          </h1>
          <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
            Du har ikke tilladelse til at tilgå denne side. Hvis du mener, dette er en fejl, bedes du kontakte administratoren eller gå tilbage til forsiden.
          </p>
        </div>

        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto rounded-xl bg-brand-green px-6 py-3 text-sm font-bold text-white shadow-md transition hover:bg-brand-green-light cursor-pointer"
          >
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto rounded-xl bg-stone-100 border border-stone-200 px-6 py-3 text-sm font-bold text-brand-stone-dark transition hover:bg-stone-200 cursor-pointer"
          >
            Kontakt værkstedet
          </Link>
        </div>
      </div>
    </div>
  );
}
